import {
  BEGINING_STOCK_LOAD_DIVISION,
  BEGINING_STOCK_LOAD_DEPARTMENT,
  BEGINING_STOCK_LOAD_SECTION,
  BEGINING_STOCK_LOAD_PLANT,
  BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE,
  BEGINING_STOCK_REMOVE_LISTS,
  UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE,
  BEGINING_STOCK_LOAD_ERROR,
  BEGINNING_STOCK_EXPORT,
} from './actions'

const initialState = {
  loading_division: false,
  division_list: [],

  loading_department: false,
  department_list: [],

  loading_section: false,
  section_list: [],

  loading_plant: false,
  plant_list: [],

  loading_data_source_for_table: false,
  data_source_for_table: {},

  loading_update_data_source_for_table_status: false,
  update_data_source_for_table_status: false,

  loading_error: false,
  data_error: [],

  loading_export: false,
  export_data: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case BEGINING_STOCK_REMOVE_LISTS:
      return initialState

    case BEGINING_STOCK_LOAD_ERROR.REQUEST:
      return {
        ...state,
        loading_error: true,
        data_error: [],
      }

    case BEGINING_STOCK_LOAD_ERROR.SUCCESS:
      return {
        ...state,
        loading_error: false,
        data_error: action.payload.lists,
      }

    // *load division
    case BEGINING_STOCK_LOAD_DIVISION.REQUEST:
      return {
        ...state,
        loading_division: true,
        division_list: [],
      }
    case BEGINING_STOCK_LOAD_DIVISION.SUCCESS:
      return {
        ...state,
        loading_division: false,
        division_list: action.payload.lists,
      }

    case BEGINING_STOCK_LOAD_DIVISION.FAILURE:
      return {
        ...state,
        loading_division: false,
        division_list: [],
      }

    // *load department
    case BEGINING_STOCK_LOAD_DEPARTMENT.REQUEST:
      return {
        ...state,
        loading_department: true,
        department_list: [],
      }
    case BEGINING_STOCK_LOAD_DEPARTMENT.SUCCESS:
      return {
        ...state,
        loading_department: false,
        department_list: action.payload.lists,
      }
    case BEGINING_STOCK_LOAD_DEPARTMENT.FAILURE:
      return {
        ...state,
        loading_department: false,
        department_list: [],
      }

    // *load section
    case BEGINING_STOCK_LOAD_SECTION.REQUEST:
      return {
        ...state,
        loading_section: true,
        section_list: [],
      }
    case BEGINING_STOCK_LOAD_SECTION.SUCCESS:
      return {
        ...state,
        loading_section: false,
        section_list: action.payload.lists,
      }
    case BEGINING_STOCK_LOAD_SECTION.FAILURE:
      return {
        ...state,
        loading_section: false,
        section_list: [],
      }

    // *load plant
    case BEGINING_STOCK_LOAD_PLANT.REQUEST:
      return {
        ...state,
        loading_plant: true,
        plant_list: [],
      }
    case BEGINING_STOCK_LOAD_PLANT.SUCCESS:
      return {
        ...state,
        loading_plant: false,
        plant_list: action.payload.lists,
      }
    case BEGINING_STOCK_LOAD_PLANT.FAILURE:
      return {
        ...state,
        loading_plant: false,
        plant_list: [],
      }

    // *load data source for table
    case BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE.REQUEST:
      return {
        ...state,
        loading_data_source_for_table: true,
        data_source_for_table: {},
      }
    case BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE.SUCCESS:
      return {
        ...state,
        loading_data_source_for_table: false,
        data_source_for_table: action.payload.lists,
      }
    case BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE.FAILURE:
      return {
        ...state,
        loading_data_source_for_table: false,
        data_source_for_table: {},
      }

    // *update data source for table
    case UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE.REQUEST:
      return {
        ...state,
        loading_update_data_source_for_table_status: true,
      }

    case UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE.SUCCESS:
      const existingDataSource = state.data_source_for_table.dataSource
      const newDataSource = action.payload.lists.dataSource

      // อัปเดตข้อมูลที่มีอยู่โดย merge เฉพาะ key ที่มีใน newDataSource
      const mergedDataSource = existingDataSource.map((existingData) => {
        const newData = newDataSource.find(
          (item) => item.id === existingData.id
        )

        if (newData) {
          return {
            ...existingData,
            ...newData,
            extra_value:
              existingData.extra_value &&
              Array.isArray(existingData.extra_value)
                ? existingData.extra_value.map((ev) => {
                    const newExtra =
                      newData.extra_value && Array.isArray(newData.extra_value)
                        ? newData.extra_value.find(
                            (nEv) => nEv.silo_no === ev.silo_no
                          )
                        : undefined
                    return newExtra ? { ...ev, ...newExtra } : ev
                  })
                : newData.extra_value || [],
          }
        }
        return existingData
      })

      // เพิ่มข้อมูลใหม่ที่ไม่มีอยู่ใน existingDataSource
      const finalDataSource = [
        ...mergedDataSource,
        ...newDataSource.filter(
          (newData) =>
            !existingDataSource.some(
              (existingData) => existingData.id === newData.id
            )
        ),
      ]

      return {
        ...state,
        loading_update_data_source_for_table_status: false,
        update_data_source_for_table_status: true,
        data_source_for_table: {
          ...state.data_source_for_table,
          dataSource: finalDataSource,
        },
      }

    case UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE.FAILURE:
      return {
        ...state,
        loading_update_data_source_for_table_status: false,
        update_data_source_for_table_status: false,
      }

    // *export ข้อมูล
    case BEGINNING_STOCK_EXPORT.REQUEST:
      return {
        ...state,
        loading_export: true,
        export_data: {},
      }
    case BEGINNING_STOCK_EXPORT.SUCCESS:
      return {
        ...state,
        loading_export: false,
        export_data: action.payload.lists,
      }
    case BEGINNING_STOCK_EXPORT.FAILURE:
      return {
        ...state,
        loading_export: false,
        export_data: {},
      }

    default:
      return state
  }
}
